import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class CardsReveal {
    constructor() {
        this.blocks = document.querySelectorAll(".cards-reveal");

        if (this.blocks && this.blocks.length > 0) {
            this.initCardsReveal();
        }
    }

    initCardsReveal() {
        this.blocks.forEach(block => {

            const cards = block.querySelectorAll(".item-card");
            cards.forEach((card, index) => {
                const mm = gsap.matchMedia();
                mm.add("(min-width: 991px)", () => {
                    const yOffset = 200 + index * 100;
                    gsap.fromTo(card, {
                        opacity: 0,
                        y: yOffset,
                    }, {
                        opacity: 1,
                        y: 0,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: block,
                            start: "top bottom",
                            end: "center center",
                            scrub: true,
                        }
                    });
                });
            });
        });
    }
}
